import { render, staticRenderFns } from "./ContestInstructions.vue?vue&type=template&id=65caef10&scoped=true&"
import script from "./ContestInstructions.vue?vue&type=script&lang=js&"
export * from "./ContestInstructions.vue?vue&type=script&lang=js&"
import style0 from "./ContestInstructions.vue?vue&type=style&index=0&id=65caef10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65caef10",
  null
  
)

export default component.exports